import { HttpClient } from 'api/HttpClient';
import {
  AcceptOfferRequestDto,
  AcceptOfferResponseDto,
  DeclineOfferRequestDto,
  DeclineOfferResponseDto,
  OfferResponseDto,
  OffersRequestDto,
  OffersResponseDto,
} from 'api/AutomatedOffersApi';

export interface UpdateOfferRequestDto {
  applicationId: string;
  loanAmount: number;
  loanTerm: string;
}

export default class AutomatedOffersApi extends HttpClient {
  public constructor() {
    super(process.env.REACT_APP_API_URL + '/small-loan-program/automated-offers');
  }

  public async acceptOffer(acceptOfferDto: AcceptOfferRequestDto): Promise<AcceptOfferResponseDto> {
    return this.instance.post('/accept', acceptOfferDto).then((response) => response.data);
  }

  public async getOffers(offersRequestDto: OffersRequestDto): Promise<OffersResponseDto> {
    return this.instance.post('', offersRequestDto).then((response) => response.data);
  }

  public async getOffer(applicationId: string, loanAmount: number, loanTerm: string): Promise<OfferResponseDto> {
    return this.instance
      .get(`/offer?applicationId=${applicationId}&loanAmount=${loanAmount}&loanTerm=${loanTerm}`)
      .then((response) => response.data);
  }

  public async declineOffer(declineOfferDto: DeclineOfferRequestDto): Promise<DeclineOfferResponseDto> {
    return this.instance.put('/decline', declineOfferDto).then((response) => response.data);
  }

  public async updateOffer(updateOfferDto: UpdateOfferRequestDto): Promise<void> {
    return this.instance.put('', updateOfferDto).then((response) => response.data);
  }
}

export const posAutomatedOffersApi = new AutomatedOffersApi();
